import React from 'react';
import styled, { css } from 'styled-components';

import { TitleSmallText, FontColor } from '@prisjakt/ui/text/variants';

type Props = {
  diffPercentage: number;
  marginRem?: number;
  position?: 'relative' | 'absolute';
};

export const DealBadge = (props: Props) => {
  const { diffPercentage, marginRem = 1, position = 'absolute' } = props;

  return (
    <DiffPercentage $marginRem={marginRem} $position={position}>
      <TitleSmallText color={FontColor.LIGHT}>
        -{Math.round(diffPercentage)}%
      </TitleSmallText>
    </DiffPercentage>
  );
};

type StyledProps = {
  $position: 'relative' | 'absolute';
  $marginRem: number;
};

export const DiffPercentage = styled.div<StyledProps>(
  p => css`
    background: ${p.theme.colors.redio500};
    padding: 0.1rem 0.4rem;
    border-radius: 2px;

    ${p.$position === 'absolute' &&
    css`
      position: absolute;
      top: 0;
      left: ${p.$marginRem}rem;
    `}
  `
);
